import React from 'react';
import './Cards.css';
import CardItem from './Carditem';

function Cards2() {
  return (
    <div className='cards'>
      <h1>Finding your perfect companion has never been easier. </h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/S1.jpg'
              text='Find pets from multiple adoption centers in your area. '
              path='/signup'
            />
            <CardItem
              src='images/S2.jpg'
              text='Filter different options to find your perfect match.'
              path='/signup'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/S3.jpg'
              text='Contact the shelter to schedule a visit with the click of a button.'
              path='/signup'
            />
            <CardItem
              src='images/D2.jpg'
              text='Help your new best friend find their forever home.'
              path='/signup'
            />
            <CardItem
              src='images/D4.jpg'
              text='Finding happy homes for pets is your passion. Its ours too.'
              path='/signup'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards2;